import secureApi from '../../utils/secureApi';

interface WeeklyReport {
  _id: string;
  title: string; // Weekly reports use 'title'
}

interface ApiResponse {
  statusCode: number;
  status: string;
  message: string;
  data: WeeklyReport[];
}

export const getWeeklyReportDropdown = async (search: string = ''): Promise<WeeklyReport[]> => {
  try {
    const params: any = {
      page: 1,
      pageSize: 50,
    };
    if (search) params.search = search;

    // Build query string
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      queryParams.append(key, params[key].toString());
    });

    const response = await secureApi.get<any>(
      `/api/v2/tournaments/admin/weeklyReports/dropdown?${queryParams.toString()}`
    );
    
    // Handle API response structure: secureApi returns response.data automatically
    // API may return: { statusCode: 200, status: "success", data: [...] } or direct array
    if (Array.isArray(response)) {
      return response;
    } else if (response && response.data && Array.isArray(response.data)) {
      return response.data;
    } else if (response && Array.isArray(response)) {
      return response;
    }
    return [];
  } catch (error) {
    console.error('Failed to fetch weekly reports for dropdown:', error);
    return [];
  }
}; 